import Vue from 'vue';
import Router from 'vue-router';

import ResetPassword from './components/ResetPassword.vue';
import PasswordLinkExpired from './components/PasswordLinkExpired.vue';
import ForgotPassword from './components/ForgotPassword.vue';
import Login from './components/Login.vue';
import LoginTokenView from './components/LoginTokenView';
import OktaVue from '@okta/okta-vue';
import {OktaAuth} from '@okta/okta-auth-js';
import sampleConfig from './config';

const oktaAuth = new OktaAuth({
    issuer: sampleConfig.oidc.issuer,
    clientId: sampleConfig.oidc.clientId,
    redirectUri: window.location.origin + '/login/callback',
    scopes: ['openid', 'profile', 'email']
});

Vue.use(OktaVue, {oktaAuth});
Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: Login
        }, {
            path: '/reset-password',
            name: 'reset-password',
            component: ResetPassword
        }, {
            path: '/password-link-expired',
            name: 'password-link-expired',
            component: PasswordLinkExpired
        }, {
            path: '/forgot-password',
            name: 'forgot-password',
            component: ForgotPassword
        }, {
            path: '/token-login',
            name: 'token-login',
            component: LoginTokenView
        }
    ]
});
